/**
 * ساخت لینکِ «نتیجه‌ی جستجو در یک مقصد مشخص» (برند، دسته‌بندی، محصول).
 *
 * قبلا همه‌جا دستی `${seo_full_url}?q=${search}` نوشته می‌شد. مشکل این است که
 * `seo_full_url` همیشه یک مسیر خالی نیست؛ بک‌اند برای برندها آدرسی برمی‌گرداند
 * که خودش کوئری‌استرینگ دارد:
 *
 *   /products/clothing/crop-tops?brands=farnaz-hajati
 *
 * پس چسباندن `?q=...` یک علامت سوال دوم می‌سازد
 * (`...?brands=farnaz-hajati?q=فرناز`) و مرورگر کل رشته را یک پارامتر واحد
 * می‌بیند: `brands = "farnaz-hajati?q=فرناز"`. نتیجه اینکه اسلاگ برند خراب
 * می‌شود، `q` اصلا وجود ندارد، و صفحه «۰ محصول» نشان می‌دهد.
 *
 * ضمنا خودِ عبارت هم باید encode شود؛ وگرنه عبارتی مثل «کت & شلوار» از روی
 * `&` به دو پارامتر تکه‌تکه می‌شود.
 */
export const with_search_query = (url, search) => {
    const term = typeof search === "string" ? search.trim() : "";
    const base = typeof url === "string" ? url.trim() : "";

    // بدون مقصد، تنها جای معقول صفحه‌ی جستجوی سراسری است؛ رشته‌ی خالی باعث
    // می‌شد لینک نسبت به مسیر فعلی باز شود و کاربر در همان صفحه بماند
    const target = base || "/search";

    // هش باید همیشه انتهای آدرس بماند، پس قبل از افزودن کوئری جدا می‌شود
    const [path_and_query, hash = ""] = target.split("#");

    // `trailingSlash: true` است؛ بدون اسلش پایانی یک ریدایرکت اضافه می‌خوریم
    const [path, query = ""] = path_and_query.split("?");
    const normalized_path = path.endsWith("/") ? path : `${path}/`;

    const search_param = term ? `q=${encodeURIComponent(term)}` : "";
    const merged_query = [query, search_param].filter(Boolean).join("&");

    return (
        normalized_path +
        (merged_query ? `?${merged_query}` : "") +
        (hash ? `#${hash}` : "")
    );
};

export default with_search_query;
